import React from 'react';
import TextInputHelp from '../common/generic/TextInputHelp';
import * as yup from 'yup';
import { withFormik, Form } from 'formik';
import TextInput from '../common/generic/TextInput';
import Button from 'react-bootstrap/Button';

const AddUserInnerComp = ({ errors, type }) =>
    <Form>
        <br/>
        <TextInputHelp layout={[2,8,2]} name="name" label="Name:" placeholder={type+' Name'} error={errors.name} tooltip="Students use this name when they login"/> 
        <TextInputHelp layout={[2,8,2]} name="login" label="Username:" placeholder={'Not required for '+ ((type==='Class')?'teacher':'student') +' login'} error={errors.login} tooltip="Students use this name when they login"/>          
        <TextInput layout={[2,8]} name="pass" label="Pass:" placeholder={'Used for '+ ((type==='Class')?'teacher':'student') +' login'} error={errors.pass} />          
        <Button variant='success'>Add to {type} List</Button>
    </Form>;

const AddUserInnerCompIK = withFormik({
    validationSchema: yup.object().shape({
      name: yup.string().required('A name is Required'),
      login: yup.string().required('A name is Required')
    }), 
  })(AddUserInnerComp);

export default AddUserInnerCompIK;